module.exports = __webpack_public_path__ + "static/t6-153ca8ba8a3dcf8144a9b3380657e50c.png";